/* eslint-disable */
var accordion = document.getElementsByClassName('home-links__title');
var i;

for (i = 0; i < accordion.length; i++) {
    accordion[i].onclick = function(){
        this.classList.toggle('active');
        this.nextElementSibling.classList.toggle('show');
  }
}

